// Use this mixin in components where you need to lazy load images. Add .lozad class to any image for it to work
// Detailed docs here https://apoorv.pro/lozad.js/
import lozad from 'lozad';

export default {
    mounted() {
        this.$nextTick(() => {
            const observer = lozad();
            observer.observe();
        });
    },
};
